import * as Yup from 'yup';

export const ChangePasswordValidation = Yup.object().shape({
    password: Yup.string()
        .required('Insira a senha'),
    newPassword: Yup.string()
        .required('Insira a nova senha'),
    newPasswordConfirmation: Yup.string()
        .required('Confirme a nova senha')
        .test('passwords-match', 'As senhas digitadas estão diferentes', function (value) {
            return this.parent.newPassword === value
        })
})
